import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { articleByPath } from '../articles';

// Titre de l'onglet pendant la navigation sur le site vitrine. Au premier
// chargement, le serveur a déjà posé titre et balises (server/utils/seoPages.ts).
const TITLES: Record<string, string> = {
  '/': 'RSVP Please · Organisez gratuitement tout votre mariage',
  '/plan-de-table-mariage': 'Plan de table mariage en ligne gratuit · RSVP Please',
  '/retroplanning-mariage': 'Rétroplanning mariage : le planning complet, mois par mois · RSVP Please',
  '/budget-mariage': 'Budget mariage : prix moyen, répartition et budget par invité · RSVP Please',
  '/calculateur-boissons-mariage':
    'Calculateur boissons mariage : combien de bouteilles de vin et champagne ? · RSVP Please',
  '/rsvp-mariage': 'RSVP mariage en ligne gratuit : réponses, date limite et modèles de textes · RSVP Please',
  '/qr-code-faire-part-mariage':
    'QR code gratuit pour faire-part de mariage : vos invités répondent en un scan · RSVP Please',
  '/formulaire-reponse-mariage':
    'Formulaire de réponse mariage : questions à poser, exemple et carton réponse · RSVP Please',
  '/google-form-mariage': 'Google Form mariage : modèle de formulaire de réponse et alternative · RSVP Please',
  '/guides': 'Guides mariage : rétroplanning, budget, invités, faire-part · RSVP Please',
  '/estelle-de-truchis-de-varennes': 'Estelle de Truchis de Varennes, fondatrice de RSVP Please',
  '/liste-invites-mariage': 'Liste d’invités mariage : modèle Excel gratuit et méthode · RSVP Please',
  '/quand-envoyer-faire-part-mariage': 'Quand envoyer les faire-part de mariage (et les save the date) ? · RSVP Please',
  '/signup': 'Créer mon espace mariage gratuit · RSVP Please',
  '/login': 'Se connecter · RSVP Please',
  '/mentions-legales': 'Mentions légales · RSVP Please',
  '/confidentialite': 'Politique de confidentialité · RSVP Please',
  '/conditions': 'Conditions d’utilisation · RSVP Please',
};

export function usePageTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith('/backoffice')) return; // titre posé par le backoffice
    document.title = TITLES[pathname] ?? articleByPath(pathname)?.seoTitle ?? TITLES['/'];
  }, [pathname]);
}
